import { RouteType } from "types/RouteType";
// import designValuesRoute from "./DesignValues/designValues.Route";
import qualityControlRoute from "./QualityControl/qualityControl.Route";
// import qualityControlOverviewRoute from "./QualityControlOverview/qualityControlOverview.Route";
// New QC Workflow Routes
import qcInspectorDashboardRoute from "./InspectorDashboard/QCInspectorDashboard.Route";
import qcManagerDashboardRoute from "./ManagerDashboard/QCManagerDashboard.Route";
import qcInspectionRoute from "./InspectionForm/QCInspection.Route";
import qcApprovalRoute from "./ApprovalWorkflow/QCApproval.Route";
// Quick Action Routes
import concreteTestEntryRoute from "./ConcreteTestEntry/ConcreteTestEntry.Route";
import cylinderBreakEntryRoute from "./CylinderBreakEntry/CylinderBreakEntry.Route";
import customBOMRoute from "./CustomBOM/CustomBOM.Route";
import qcDrawingViewerRoute from "./QCDrawingViewer/QCDrawingViewer.Route";

const qualityControlRoutesList: RouteType[] = [
    // ...designValuesRoute,
    qualityControlRoute,
    // ...qualityControlOverviewRoute,
    // New QC Workflow Routes
    qcInspectorDashboardRoute,
    qcManagerDashboardRoute,
    qcInspectionRoute,
    qcApprovalRoute,
    // Quick Action Routes
    concreteTestEntryRoute,
    cylinderBreakEntryRoute,
    customBOMRoute,
    qcDrawingViewerRoute,
];

export default qualityControlRoutesList;
